const SIDEBAR_ICON_BY_APP_CODE = {
  ai_edit: "ai-edit",
  product_retouch: "product-retouch",
  watermark_remove: "watermark-remove",
  cutout: "cutout",
  model_generate: "model-generate",
  product_replace: "product-replace",
  clothes_replace: "clothes-replace",
  goods_detail: "ai-edit",
};

export function isSidebarImageURL(value) {
  return /^https?:\/\//i.test(String(value || "").trim());
}

export function normalizeSidebarToolApp(item = {}) {
  if (item.is_enabled !== true || item.show_in_home !== true) return null;

  const appCode = String(item.app_code || "").trim();
  const routePath = String(item.route_path || "").trim();
  if (!appCode || !routePath) return null;

  const rawIcon = String(item.icon || "").trim();
  const icon = SIDEBAR_ICON_BY_APP_CODE[appCode] || (isSidebarImageURL(rawIcon) ? rawIcon : "ai-edit");
  return {
    title: String(item.name || appCode).trim() || appCode,
    path: routePath,
    icon,
    iconActive: isSidebarImageURL(icon) ? icon : `${icon}-active`,
    iconHover: isSidebarImageURL(icon) ? icon : `${icon}-hover`,
  };
}

export function buildSidebarToolList(items = []) {
  return (Array.isArray(items) ? items : [])
    .map(normalizeSidebarToolApp)
    .filter(Boolean);
}
